import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BlobStorageService} from "../../services/blob-storage.service";
import {FileImportComponent, FileType} from "../../components/file-import/file-import.component";
import {DownloadService} from "../../services/download.service";
import {BlobDocumentInfo} from "../../models/blob-document-info";
import {groupToMap} from "../../helpers/group-to-map";
import {Observable} from "rxjs";
import {HttpParams} from "@angular/common/http";

@Component({
    selector: 'blob-storage',
    templateUrl: './blob-storage.component.html',
    styleUrls: ['./blob-storage.component.scss'],
    standalone: false
})
export class BlobStorageComponent implements OnInit {

    @Input() label: string
    private _documentIds: string[];
    @Input() set documentIds(val: string[]) {
        if (val && val !== this._documentIds) {
            this._documentIds = val;
            this.getFiles();
        }
    }
    get documentIds(): string[] {
        return this._documentIds;
    }
    @Input() fileTypes: string[];
    @Input() entityId: number;
    @Input() entityParent: string;
    @Input() siteId: string;
    @Input() editable: boolean = true;

    blobs: BlobDocumentInfo[] = [];
    selectedLabel: FileType;
    working: boolean = false;
    downloading: boolean = false;

    @Output() blobUploaded: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild(FileImportComponent) fileImportComponent: FileImportComponent;
    constructor(private blobStorageService: BlobStorageService,
                private downloadService: DownloadService) { }

    ngOnInit(): void {
        this.selectedLabel = this.label as FileType;
    }

    dragOverFunction(event: any, siteId: string, entityId: number, entityParent: string): Observable<string> {
        return this.fileImportComponent.blobStorageUpload(event, siteId, entityId, entityParent);
    }
    getFiles(documentId?: string): void {
        this.blobs = [];
        const documentIds = this.documentIds ?? [];
        if (documentId) {
            documentIds.push(documentId);
        }

        if (documentIds && documentIds.length > 0 && !this.working) {
            this.working = true;
            const params = new HttpParams().appendAll({documentIds});
            this.blobStorageService.GetBlobDocumentsInfo(params).subscribe({
                next: blobs => {const grouped = groupToMap(blobs, x => x.fileType);
                grouped.forEach((value, key) => {
                    value.forEach(x => x.index = value.indexOf(x) + 1);
                });
                this.blobs = [...grouped.values()].flatMap(x => x);
                this.blobUploaded.emit(blobs[blobs.length-1].id);
            },
                error: () => this.working = false,
                complete: () => this.working = false
            });
        }
    }

    downloadFile(fileId: string): void {
        this.downloading = true;
        this.blobStorageService.GetBlobFile(fileId).subscribe({
            next: response => {
                const fileName = response.headers.get('Content-Disposition').split(';')[1].split('=')[1].replace(/"/g, '');
                console.log(fileName);
                this.downloadService.Download(response.body, fileName);
                this.downloading = false;
            },
            error: ()=> this.downloading = false,
            complete: () =>this.working = false
    });
    }

    deleteFile(fileId: string) {
        this.downloading = true;
        this.blobStorageService.DeleteBlobFile(fileId).subscribe({
            next:() => {
                this.documentIds.splice(this.documentIds.indexOf(fileId), 1);
                this.getFiles();
                this.downloading = false;
            },
            error: () => this.downloading = false,
            complete: () =>this.working = false
        });
    }

    addDocument(e: string) {
        this.getFiles(e);
    }
}
